import { useSnackbar } from "notistack";
import * as React from "react";

import { useDeviceSize, useRouter } from "../hooks";
import { ModalNotification } from "./modalNotification";
import { notificationActions } from "./notificationActions";
import { notificationsReducer } from "./notificationsReducer";
import { NotificationsState } from "./notificationState";

export interface INotificationsContext {
    state: NotificationsState;
    actions: ReturnType<typeof notificationActions>;
}

export const NotificationsContext = React.createContext<
    INotificationsContext | undefined
>(undefined);
const initialState = {
    messages: [],
};
export const NotificationsProvider = (props: { children: React.ReactNode }) => {
    const [state, dispatch] = React.useReducer(
        notificationsReducer,
        initialState
    );
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const device = useDeviceSize();

    const {
        location: { pathname, search },
    } = useRouter();

    const modalNotification = state.messages.find(m => m.type === "modal");

    const actions = React.useMemo(
        () =>
            notificationActions(
                dispatch,
                device,
                enqueueSnackbar,
                closeSnackbar
            ),
        [closeSnackbar, device, enqueueSnackbar]
    );

    React.useEffect(() => {
        actions.closeAllAreaNotifications();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, search, actions]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const value = React.useMemo(() => ({ state, actions }), [actions, state]);
    return (
        <NotificationsContext.Provider value={value}>
            <>
                {!!modalNotification ? (
                    <ModalNotification
                        notificationKey={modalNotification.key}
                        level={modalNotification.level}
                        title={modalNotification.title}
                        message={modalNotification.message}
                        onClose={modalNotification.callback}
                        canClose={modalNotification.canClose}
                        customIcon={modalNotification.customIcon}
                    />
                ) : null}
                {props.children}
            </>
        </NotificationsContext.Provider>
    );
};
